/// <reference path="../../../Modules/Attr/Grid/NoboxEntityGrid.ts" />
namespace Nobox.Administration {
    import fld = UserRoleRow.Fields;
    @Serenity.Decorators.registerClass()
    export class UserRoleGrid extends NoboxEntityGrid<UserRoleRow, any> {
        protected getColumnsKey() { return UserRoleColumns.columnsKey; }
        protected getIdProperty() { return UserRoleRow.idProperty; }
        protected getInsertPermission() { return UserRoleRow.insertPermission; }
        protected getLocalTextPrefix() { return UserRoleRow.localTextPrefix; }
        protected getService() { return UserRoleService.baseUrl; }

        public userName: string;
        constructor(container: JQuery) {
            super(container);
        }

        protected getColumns() {
            var columns = super.getColumns();

            columns.push({
                field: 'Edit Roles',
                name: '',
                format: (ctx) => {
                    return `<a class="inline-action role-user" title="Edit Roles">
                        <i class="fa fa-users text-blue"></i></a>`;
                },
                width: 24,
                minWidth: 24,
                maxWidth: 24
            });
            return columns;
        }

        protected onClick(e: JQueryEventObject, row: number, cell: number) {
            super.onClick(e, row, cell);

            if (e.isDefaultPrevented())
                return;

            var $this = this;
            var item = this.itemAt(row);
            var target = $(e.target);

            // if user clicks "i" element, e.g. icon
            if (target.parent().hasClass('inline-action'))
                target = target.parent();

            if (target.hasClass('inline-action')) {
                e.preventDefault();

                if (target.hasClass('role-user')) {

                    var dlg = new UserRoleDialog({
                        tenantID: item.TenantId,
                        userID: parseInt(this._UserID),
                        username: this.userName
                    });
                    dlg.dialogOpen();
                    dlg.element.on('dialogclose', () => {
                        $this.refresh();
                    });
                }
            }
        }

        protected getViewOptions(): Slick.RemoteViewOptions {
            var opt = super.getViewOptions();
            opt.url = Q.resolveUrl('~/Services/' + this.getService() + '/ListByUser');
            return opt;
        }
        protected onViewSubmit(): boolean {
            if (!super.onViewSubmit()) { return false; }
            let request = this.view.params as Serenity.ListRequest;
            request.Criteria = Serenity.Criteria.and(request.Criteria, [[fld.UserId], "=", this._UserID]); return true;
        }

        private _UserID: string;

        get userId() {
            return this._UserID;
        }
        set userId(value: string) {
            if (this._UserID !== value) {
                this._UserID = value;
                this.refresh();
            }
        }
    }
}